const REQUIRED_PARTICIPANT = ["first_name", "last_name", "dob", "gender", "tshirt_size", "shorts_size", "socks_size"];
const REQUIRED_GUARDIAN = ["first_name", "last_name", "email", "phone"];

function ageOnCampStart(dobStr) {
  const dob = new Date(dobStr);
  const ref = new Date("2027-06-09");
  let age = ref.getFullYear() - dob.getFullYear();
  const m = ref.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && ref.getDate() < dob.getDate())) age--;
  return age;
}

// Returns an error message or null.
export function participantsError(participants) {
  for (const [i, p] of participants.entries()) {
    if (REQUIRED_PARTICIPANT.some((f) => !String(p[f] || "").trim())) return `Participant ${i + 1}: please complete all required fields.`;
    const age = ageOnCampStart(p.dob);
    if (age < 6 || age > 17) return `Participant ${i + 1} must be aged 6-17 on June 9, 2027 (age ${age}).`;
  }
  return null;
}

export function guardianError(guardian, consents) {
  if (REQUIRED_GUARDIAN.some((f) => !String(guardian[f] || "").trim())) return "Please complete all required guardian fields.";
  if (!/^\S+@\S+\.\S+$/.test(guardian.email)) return "Please enter a valid email address.";
  if (!(consents.guardian_confirm && consents.terms && consents.privacy && consents.medical_share)) return "Please accept all required consents to continue.";
  return null;
}
